import React from "react"

import CloseIcon from "@mui/icons-material/Close"
import DownloadIcon from "@mui/icons-material/Download"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material"

import type { Report } from "../../models/report"
import DownloadCsv from "../downloadCsv/downloadCsv"
import inReviewIllustration from "./images/in-review.svg"

interface IDownloadPreviewCsvProps {
  isDisabled: boolean
  isLoading: boolean
  // Mass eslint disable @typescript-eslint/no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  report: Report<any> | Report<any>[]
  variant?: "contained" | "text"
}

const DownloadPreviewCsv = ({
  isDisabled,
  isLoading,
  report,
  variant,
}: IDownloadPreviewCsvProps) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const handleOpen = (): void => {
    setIsOpen(true)
  }
  const handleClose = (): void => {
    setIsOpen(false)
  }

  return (
    <>
      <Button
        disabled={isDisabled}
        endIcon={<DownloadIcon />}
        loading={isLoading}
        onClick={handleOpen}
        title="Download Preview CSV"
        variant={variant ?? "contained"}
      >
        Download Preview CSV
      </Button>
      <Dialog
        aria-describedby="Download preliminary emissions data via csv"
        aria-labelledby="Get ready for reporting season"
        fullWidth
        maxWidth="xs"
        onClose={handleClose}
        open={isOpen}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <IconButton
            color="neutral"
            onClick={handleClose}
            size="small"
            sx={{
              position: "absolute",
              right: "16px",
              top: "16px",
            }}
            title="Close Icon"
          >
            <CloseIcon />
          </IconButton>
          <Box
            alt=""
            aria-hidden="true"
            component="img"
            src={inReviewIllustration}
            sx={{
              height: "205px",
              mb: 3,
              mt: 1,
              width: "271px",
            }}
          />
          <Box>
            <Typography
              component="h1"
              sx={{
                fontWeight: "bold",
                mb: 1,
              }}
            >
              Get ready for reporting season
            </Typography>
            <Typography variant="body2">
              Take a look at your preliminary emissions data and familiarize
              yourself with the report formatting.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} title="Close">
            Close
          </Button>
          <DownloadCsv
            onClick={handleClose}
            report={report}
            title="Download Preview CSV"
          />
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DownloadPreviewCsv
